import { FilterService } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';

export class FilterHelper {
  public static initializeFilter<T>(field: string, value: T): CompositeFilterDescriptor {
    return {
      filters: [
        {
          field: field,
          operator: 'eq',
          value: value,
        },
      ],
      logic: 'and',
    } as CompositeFilterDescriptor;
  }

  public static filterChange<T>(
    selectedValue: T,
    filterService: FilterService,
    filterField: string
  ): void {
    filterService.filter({
      filters: [
        {
          field: filterField,
          operator: 'eq',
          value: selectedValue,
        },
      ],
      logic: 'and',
    });
  }

  public static extractFromFilter<T>(filter: CompositeFilterDescriptor, filterField: string): T {
    const statusFilter = <FilterDescriptor>filter.filters.find(f => f['field'] === filterField);

    return statusFilter ? (statusFilter.value as T) : null;
  }

  public static flatten(
    filter: CompositeFilterDescriptor,
    flattenFilters: FilterDescriptor[] = []
  ): FilterDescriptor[] {
    filter.filters.forEach(f =>
      this.isCompositeFilterDescriptor(f) ? this.flatten(f, flattenFilters) : flattenFilters.push(f)
    );

    return flattenFilters;
  }

  private static isCompositeFilterDescriptor(
    filterDescriptor: FilterDescriptor | CompositeFilterDescriptor
  ): filterDescriptor is CompositeFilterDescriptor {
    return (<CompositeFilterDescriptor>filterDescriptor).filters !== undefined;
  }
}
